import "../../styles/about/aboutReason.css";

const AboutReason = () => {
  return (
    <section className="about-reason">
      <div className="about-reason-inner">
        <h2 className="about-reason-title">Why VisualLab?</h2>

        <p className="about-reason-text">
          Learning complex concepts through plain text is slow, boring, and
          often confusing. VisualLab was created to bridge this gap by combining
          theory with interactive visualizations.
        </p>

        <p className="about-reason-text">
          Instead of passively reading, users can explore ideas visually,
          understand how things work step-by-step, and build stronger intuition
          through animations and structured explanations.
        </p>
      </div>
    </section>
  );
};

export default AboutReason;
